import '@/i18n'
import '@/styles/index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import { bootstrapApplication } from '@/app/bootstrap'
import { UnsupportedEnvironment } from '@/app/UnsupportedEnvironment'
import { TelegramEnvironmentError } from '@/telegram'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root is missing in index.html')
}
const root = createRoot(rootElement)

bootstrapApplication()
  .then(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  })
  .catch((bootstrapError: unknown) => {
    if (!(bootstrapError instanceof TelegramEnvironmentError)) {
      console.error(bootstrapError)
    }
    root.render(
      <StrictMode>
        <UnsupportedEnvironment />
      </StrictMode>,
    )
  })
